import { Box, ColorOptions, Icon, TextNew as Text } from '@jfs/ui-new'
import * as React from 'react'
import { useState } from 'react'
import { Dimensions, ScrollView } from 'react-native'
import { CardType } from '../../data/models/Card'
import { useLazyApiData, useStores } from '../../data/store'
import { CardVendors } from '../../utils'
import { THEME_PADDING } from '../../utils/constants'
import { ToastMessage } from '../ToastMessageV2'
import { SavedCards } from './SavedCards'
import { CardComponent } from './SavedCards/AddCard'
import { ModalDialogDelete } from './SavedCards/ModalDialogDelete'
import { creditCardStyles } from './styles'

// TODO: Code Cleanup & Follow Code Pattern

interface CardDetails {
  cardNumber: string
  cardHolderName: string
  expiry: string
  cvv: string
  isSaveCard?: boolean
  token?: string
  scheme?: number
  type?: number
  isNewCard?: boolean
}

interface CreditCardProps {
  onPayment: (values: CardDetails) => void
  onCardNumberBlur?: (cardVendor: CardVendors, cardNumber: string) => void
  isValid?: boolean
  savedCards?: any
  errMsg?: string
  amount?: string
  emiTotalAmount?: string
  theme?: any
  onCardNumberChange?: (cardNumber: string) => void
  onDelete?: (id: string) => void
  headerComp?: React.ReactNode
  btnFooter?: React.ReactNode
  scFotterComp?: React.ReactNode
  cardFotterComp?: React.ReactNode //To Show Footer in below CardExpiry
  cardNumFooter?: React.ReactNode
  scHeaderComp?: React.ReactNode
  isEMI?: boolean
  isCardEMIEligible?: boolean
  isPayButtonEnable?: boolean
  showButton?: boolean
  emiCards?: [CardType]
  nonEMICards?: [CardType]
  onCardSelected?: (item: any) => void
  onClickGetBalance?: (item: any) => void
  isLoading?: boolean
  onAddNewCard?: () => void
  onModalState?: (modelState: boolean) => void
  showAddeNew: boolean
  btnTitle?: string
  errorColor?: ColorOptions
  onSaveCardVisible?: (isVisible: boolean) => void
  setCurCardVendor?: (cardVendor: string) => void
  isFoodCard?: boolean
  showSCCheckBox?: boolean
  onCardNumberValid?: (isValid: boolean) => void
  isSubscriptionEnabled?: boolean
}

const CreditCard = ({
  onPayment,
  onCardNumberBlur,
  isValid = true,
  onDelete = () => { },
  errMsg = '',
  amount,
  emiTotalAmount,
  theme,
  onCardNumberChange = () => { },
  headerComp = null,
  btnFooter = null,
  scFotterComp = null,
  cardFotterComp = null,
  scHeaderComp = null,
  isEMI = false,
  isCardEMIEligible = false,
  emiCards,
  nonEMICards,
  showButton = true,
  onCardSelected = () => { },
  onClickGetBalance = () => { },
  isLoading = false,
  onAddNewCard = () => { },
  onModalState,
  showAddeNew = false,
  isPayButtonEnable = false,
  btnTitle,
  errorColor,
  onSaveCardVisible,
  setCurCardVendor,
  isFoodCard = false,
  cardNumFooter,
  onCardNumberValid,
  showSCCheckBox = true,
  isSubscriptionEnabled = false,
  savedCards = [],
}: CreditCardProps) => {
  const [selected, setSelected] = useState<'newcard' | 'savedcards' | undefined>()
  // TextInputs Values
  const [cvv, setCvv] = useState('')
  const isEnoughSpace = Dimensions.get('screen').height > 600

  const { deleteCardApi, getCards } = useStores((root) => ({
    deleteCardApi: root.deleteCardApi,
    getCards: root.getCards,
  }))
  const [lazyDeleteCardApi, { state: deleteCardState, data: deleteCardData }] = useLazyApiData(deleteCardApi)

  const styles = creditCardStyles(theme)
  const [selectedItem, setSelectedItem] = useState({
    maskedCardNumber: '',
    name: '',
    expirySavedCard: '',
    cvvSavedCard: '',
    token: '',
    isCvvLess:false,
    type: 0,
    scheme: 0,
    cardBalance: {
      balance: '',
      isLoading: false,
      error: '',
    },
  })
  const [isEMIEligible, setIsEMIEligible] = useState(false)
  const [showToastMessage, setShowToastMessage] = React.useState(false)
  const [deleteCardItem, setDeleteCardItem]: any = React.useState({})
  const [confirmAlertInfo, setConfirmAlertInfo] = React.useState(false)
  const [isDeleting, setIsDeleting] = useState(false)

  React.useEffect(() => {
    if (deleteCardState === 'pending') {
      setIsDeleting(true)
    } else if (deleteCardState === 'fulfilled') {
      setIsDeleting(false)
      setConfirmAlertInfo(false)
      const getNewCardList = getCards()
      if (getNewCardList < 1) {
        onModalState(!showAddeNew)
        onAddNewCard()
      }
      if (deleteCardData?.status === 'SUCCESS') {
        setShowToastMessage(true)
      }
    } else if (deleteCardState === 'rejected') {
      setIsDeleting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteCardState])

  const paymentThroughSavedCard = ({
    maskedCardNumber,
    name,
    expirySavedCard,
    cvvSavedCard,
    token,
    type,
    scheme,
  }: {
    maskedCardNumber: string
    name: string
    expirySavedCard: string
    cvvSavedCard: string
    token: string
    scheme: number
    type: number
  }) => {
    console.log(
      '===> paymentThroughSavedCard',
      maskedCardNumber,
      name,
      expirySavedCard,
      cvvSavedCard,
      token,
      type,
      scheme,
    )
    try {
      onPayment({
        cardNumber: maskedCardNumber,
        cardHolderName: name,
        expiry: expirySavedCard,
        cvv: cvvSavedCard,
        token,
        scheme,
        type,
      })
    } catch (err) {
      console.log('===> paymentThroughSavedCard catch err: ', err.message)
      console.log(err.message)
    }
  }

  const proceedToPayment = (item: any) => {
    console.log('===> proceedToPayment : ', item)
    paymentThroughSavedCard({
      maskedCardNumber: item?.cardNumber,
      name: item?.ownerName,
      expirySavedCard: item?.expiry,
      cvvSavedCard: cvv,
      token: item?.token,
      type: item?.subtype,
      scheme: item?.scheme,
    })
  }

  const onEnablePayButton = (cvv: string, item: any, isEMIEligible: boolean) => {
    console.log('onEnablePayButton ~ cvv', cvv, isEMIEligible)
    console.log('===> onEnablePayButton', item)
    setSelectedItem(item)
    setIsEMIEligible(isEMIEligible)
    setCvv(cvv)
  }

  //For saved card list payment button
  const isDisablePayButton = () => {
    let isDisable = true
    //For food card if balance is not there then will enable the button
    //If balance is there that should be morethan equal to one rupee and
    //more that transaction amount then only will enable the button
    if (isFoodCard && selectedItem?.name?.length > 0) {
      if (
        !selectedItem?.cardBalance?.balance ||
        (Number(selectedItem?.cardBalance?.balance) >= 1 &&
          Number(selectedItem?.cardBalance?.balance) >= Number(amount))
      ) {
        isDisable = false
      }
      // For normal card if cvv is there then will enable the button
    } else if (!isFoodCard && (cvv|| selectedItem.isCvvLess)) {
      isDisable = false
    }
    return isDisable
  }

  return (
    <Box {...styles.mobileContainer(isEnoughSpace)}>
      <ScrollMobileContainer isEnoughSpace={isEnoughSpace}>
        <Box {...styles.mobileInnerContainer}>
          <SavedCards
            onPayment={paymentThroughSavedCard}
            selected={selected ?? 'savedcards'}
            amount={amount}
            setSelected={setSelected}
            headerComp={headerComp}
            btnFooter={btnFooter}
            onDelete={onDelete}
            cards={savedCards}
            hide={savedCards.length === 0}
            onCardNumberBlur={onCardNumberBlur}
            onCardNumberChange={onCardNumberChange}
            isValid={isValid}
            errMsg={errMsg}
            onCardPayment={onPayment}
            enablePayButton={onEnablePayButton}
            theme={theme}
            scFotterComp={scFotterComp}
            cardFotterComp={cardFotterComp}
            scHeaderComp={scHeaderComp}
            isEMI={isEMI}
            emiCards={emiCards}
            nonEMICards={nonEMICards}
            onCardSelected={onCardSelected}
            onClickGetBalance={onClickGetBalance}
            isLoading={isLoading}
            onAddNewCard={onAddNewCard}
            btnTitle={btnTitle}
            onModalState={onModalState}
            showAddeNew={showAddeNew}
            onSaveCardVisible={onSaveCardVisible}
            setCurCardVendor={setCurCardVendor}
            isFoodCard={isFoodCard}
            showSCCheckBox={showSCCheckBox}
            cardNumFooter={cardNumFooter}
            onCardNumberValid={onCardNumberValid}
            isSubscriptionEnabled={isSubscriptionEnabled}
            setShowToastMessage={setShowToastMessage}
            setDeleteCardItem={setDeleteCardItem}
            setConfirmAlertInfo={setConfirmAlertInfo}
          />
          <CardComponent
            hide={isFoodCard || savedCards.length !== 0 || false}
            onPayment={onPayment}
            headerComp={headerComp}
            btnFooter={btnFooter}
            onCardNumberBlur={onCardNumberBlur}
            onCardNumberChange={onCardNumberChange}
            isValid={isValid}
            errorColor={errorColor}
            amount={amount}
            errMsg={errMsg}
            theme={theme}
            fotterComp={cardFotterComp}
            isEMI={isEMI}
            isLoading={isLoading}
            isEMIEligible={isCardEMIEligible}
            isPayButtonEnable={isPayButtonEnable}
            btnTitle={btnTitle}
            onSaveCardVisible={onSaveCardVisible}
            setCurCardVendor={setCurCardVendor}
            showSCCheckBox={showSCCheckBox}
            cardNumFooter={cardNumFooter}
            onCardNumberValid={onCardNumberValid}
            isSubscriptionEnabled={isSubscriptionEnabled}
          />
        </Box>
      </ScrollMobileContainer>

      <ToastMessage
        isCard={true}
        show={showToastMessage}
        onCancel={() => setShowToastMessage(false)}
        cardNumber={deleteCardItem?.cardNumber?.slice(-6)}
      />

      {isEMI && emiCards && emiCards?.length > 0 && nonEMICards && nonEMICards?.length > 0 && (
        <Box padding={16} justifyContent="flex-end" backgroundColor={theme?.bodyBgColor}>
          <Box
            backgroundColor={theme?.brandColor}
            disabled={cvv ? (isEMIEligible ? (showButton ? false : true) : false) : true}
            onPress={() => {
              proceedToPayment(selectedItem)
            }}
            testID={'paySecureBtn'}
            width={'100%'}
            flexDirection={'row'}
            height={48}
            borderRadius={8}
            alignItems={'center'}
            opacity={cvv ? (isEMIEligible ? (showButton ? 1 : 0.5) : 1) : 0.5}
            underlayColor={theme?.brandColor as ColorOptions}
            justify={'center'}>
            <Icon id={'LOCK'} size={20} color={theme?.headingText as ColorOptions} />
            <Box ph={8}>
              <Text color={theme?.headingText as ColorOptions} type={'bodySecondary14'}>
                {isEMI && isEMIEligible && emiTotalAmount
                  ? `Pay ₹ ${emiTotalAmount} through EMIs`
                  : amount
                    ? `Pay ₹ ${amount}`
                    : 'Pay Securely'}
              </Text>
            </Box>
          </Box>
        </Box>
      )}
      {!isEMI && savedCards.length !== 0 && (
        <Box
          paddingHorizontal={THEME_PADDING.HORIZONTAL_PADDING}
          paddingVertical={THEME_PADDING.VERTICAL_PADDING}
          justifyContent="flex-end"
          backgroundColor={theme?.bodyBgColor}>
          <Box
            backgroundColor={theme?.brandColor}
            disabled={isDisablePayButton()}
            onPress={() => proceedToPayment(selectedItem)}
            testID={'paySecureBtn'}
            width={'100%'}
            flexDirection={'row'}
            height={48}
            borderRadius={8}
            alignItems={'center'}
            opacity={isDisablePayButton() ? 0.5 : 1}
            underlayColor={theme?.brandColor as ColorOptions}
            justify={'center'}>
            <Icon id={'LOCK'} size={20} color={theme?.headingText as ColorOptions} />
            <Box ph={8}>
              <Text color={theme?.headingText as ColorOptions} type={'bodySecondary14'}>
                {amount ? `Pay ₹ ${amount}` : 'Pay Securely'}
              </Text>
            </Box>
          </Box>
          {btnFooter && btnFooter}
          {/* <Button
            disabled={cvv ? false : true}
            type={'custom'}
            icon={'LOCK'}
            onPress={() => proceedToPayment(selectedItem)}
            title={amount ? `Pay ₹ ${amount}` : 'Pay Securely'}
            testID={'paySecureBtn'}
          /> */}
        </Box>
      )}

      <ModalDialogDelete
        show={confirmAlertInfo}
        onDismiss={() => setConfirmAlertInfo(false)}
        onProceed={() => {
          lazyDeleteCardApi(deleteCardItem?.token)
        }}
        isLoading={isDeleting}
        theme={theme}
        data={deleteCardItem}
      />
    </Box>
  )
}

const ScrollMobileContainer = ({ children, isEnoughSpace }: any) => {
  if (!isEnoughSpace) {
    return <Box flex={1}>{children}</Box>
  }

  return <ScrollView contentContainerStyle={{ ...styles.scrollContainer }}>{children}</ScrollView>
}

const styles = {
  scrollContainer: {
    flex: 1,
    height: '100%',
    width: '100%',
    backgroundColor: 'RED',
  },
}

export { CreditCard }
